
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30872',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30872",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55437",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8412",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11866",
  "I18n": "static-7.1684",
  "quartz": "static-1.7545",
  "quartz-config": "static-1.1323",
  "quartz-core": "static-1.6764",
  "react-dlb": "static-1.91",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.82",
  "reselect": "static-3.14",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.998",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55424",
  "feedback-utils": "static-1.55428",
  "forms-embed-utils-lib": "static-1.4841",
  "forms-utils-lib": "static-1.13189",
  "foundations-assets": "static-1.5264",
  "foundations-components": "static-1.8600",
  "foundations-theming": "static-1.4855",
  "hub-http": "static-1.6587",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12173",
  "icons": "static-2.696",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4169",
  "raven": "static-3.5925",
  "react": "static-7.201",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17104",
  "react-select-plus": "static-1.115",
  "react-utils": "static-2.5601",
  "react-virtualized": "static-2.109",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.510",
  "tinymce-plugins": "static-1.58346",
  "transmute": "static-2.97",
  "ui-images": "static-2.1266",
  "UIComponents": "static-3.8812",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3822",
  "quartz-webpack": "static-1.3769",
  "foundations-theming-specialty": "static-1.2571",
  "property-description-translator": "static-1.4200",
  "HeadJS": "static-2.807",
  "framer-motion": "static-1.81",
  "hs-test-utils-bend-plugin": "static-1.3523",
  "msw": "static-1.39",
  "msw-config": "static-1.11",
  "testing-library": "static-1.161",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.232",
  "moment-timezone": "static-5.93",
  "jasmine": "static-4.4687",
  "jasmine-runner": "static-1.6825",
  "opentelemetry-fe-types": "static-1.161",
  "dispatcher": "static-1.145",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.892",
  "hubspotter-http": "static-1.4904",
  "mobile-manifest-mixins": "static-1.587",
  "module-federation": "static-1.35",
  "opentelemetry-fe": "static-1.536",
  "quartz-auth": "static-1.1220",
  "quartz-head": "static-1.1210",
  "quartz-i18n": "static-1.1220",
  "quartz-routing": "static-1.975",
  "quartz-test": "static-1.1220",
  "quartz-tracking": "static-1.924",
  "trellis-components": "static-1.2854",
  "ui-fonts": "static-1.1128",
  "usage-tracker-container": "static-1.7679",
  "usage-tracker-core": "static-1.7539",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.266",
  "conversations-skeleton-state": "static-1.7600",
  "reference-resolvers": "static-1.8559",
  "sanitize-text": "static-1.8533",
  "PatternValidationJS": "static-1.3266",
  "ReduxMessenger": "static-2.10748",
  "outpost": "static-1.4514",
  "rpc-client-utils": "static-1.5042",
  "sanitize": "static-1.4848",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4869",
  "floating-ui": "static-1.65",
  "hs-story-utils": "static-1.9801",
  "react-aria": "static-1.74",
  "react-create-root-preference": "static-1.82",
  "tanstack-table": "static-1.63",
  "trellis-assets": "static-1.2835",
  "bend-plugin-foundations-theming": "static-1.3338",
  "foundations-theming-base": "static-1.3840",
  "stylex": "static-1.43",
  "hs-locale-management": "static-1.340",
  "csstype": "static-1.50",
  "web-vitals": "static-1.17",
  "ai-components-ui-library": "static-1.9857",
  "atom": "static-1.5457",
  "codemirror": "static-5.104",
  "content-assistance-lib": "static-1.8292",
  "ContentUtils": "static-1.69269",
  "data-token-picker": "static-1.16985",
  "file-manager-components": "static-1.24650",
  "FileManagerCore": "static-1.40149",
  "FileManagerLib": "static-1.40290",
  "frontend-preferences-client": "static-1.8297",
  "hub-http-contrib": "static-1.3403",
  "interframe": "static-3.5119",
  "layout-dnd-components": "static-1.13070",
  "layout-dnd-utils": "static-1.12045",
  "property-translator": "static-1.5757",
  "react-codemirror": "static-1.11019",
  "react-colorpicker": "static-2.10590",
  "reference-resolvers-lite": "static-1.8480",
  "rich-text-lib": "static-1.20411",
  "tinymce-data": "static-1.41317",
  "tinymce-themes": "static-1.57202",
  "ui-addon-emoji-picker": "static-1.10247",
  "ui-addon-sales-email": "static-1.5578",
  "ui-brand-identity-lib": "static-1.16705",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.17",
  "beacon-keepalive-queue": "static-1.81",
  "hub-http-shared-msw-handlers": "static-1.10736",
  "hubspotter-http-shared-msw-handlers": "static-1.10734",
  "usage-tracker-session-replay": "static-1.5375",
  "base-ui": "static-1.24",
  "react-day-picker": "static-1.12",
  "trellis-theming": "static-1.1353",
  "tanstack-virtual": "static-1.40",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.452",
  "chirp-fetch": "static-1.2274",
  "stylex-utils": "static-1.151",
  "chatspot-core": "static-1.23333",
  "copilot-toolkit": "static-1.11970",
  "customer-data-objects-ui-components": "static-1.13407",
  "data-fetching-client": "static-1.10024",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5136",
  "ui-addon-video-player": "static-1.9055",
  "ui-coaching-tips": "static-1.29434",
  "usage-tracker": "static-1.7689",
  "cms-field-types": "static-1.5187",
  "content-icons-ui": "static-1.2411",
  "integrations-lib": "static-1.17212",
  "customer-data-objects": "static-1.8067",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1915",
  "apollo-link-hub-http": "static-2.5011",
  "apollo-stack-hubspot": "static-3.96",
  "graphql": "static-1.91",
  "immer": "static-1.103",
  "immerable": "static-1.4521",
  "ui-addon-iframeable": "static-1.9456",
  "video-components-external": "static-1.12269",
  "video-data-lib": "static-1.35927",
  "breeze-artifacts-sdk": "static-1.571",
  "audio-components": "static-1.6441",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29910",
  "FileManagerImages": "static-1.37801",
  "foundations-components-legacy": "static-1.1625",
  "html-to-image": "static-1.63",
  "redux-toolkit": "static-1.80",
  "salesImages": "static-1.638",
  "ui-universal-auth": "static-1.9533",
  "urlinator": "static-1.4893",
  "video-components": "static-1.14271",
  "video-embed": "static-1.36761",
  "ts-schema": "static-1.4338",
  "ContentData": "static-1.69344",
  "layout-data-lib": "static-1.10370",
  "react-dnd-compat": "static-1.4991",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1922",
  "external-options-client-types": "static-1.4385",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7271",
  "hs-promise-utils": "static-1.5966",
  "inbound-db-properties-service-client": "static-1.4088",
  "NamespacedHubStyle": "static-2.9303",
  "growth-onboarding-confetti": "static-1.3441",
  "SharedI18nStrings": "static-1.185",
  "ui-addon-i18n": "static-1.11526",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5815",
  "magpie-types": "static-1.5275",
  "simple-logging-lib": "static-1.3428",
  "avatar-components": "static-1.2860",
  "customer-data-ui-utilities": "static-1.10207",
  "growth-onboarding-feedback-components": "static-1.6962",
  "flux-actions": "static-1.376",
  "hubspot-apollo-client": "static-1.5251",
  "integrations-error-boundary-lib": "static-1.14627",
  "integrations-tracking-lib": "static-1.5988",
  "laboratory-lib": "static-3.7529",
  "native-integrations-shared-strings": "static-1.8142",
  "redux-observable": "static-1.77",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10649",
  "unified-auth": "static-1.1047",
  "breeze-engine-chat-components": "static-1.893",
  "breeze-engine-core": "static-1.1193",
  "ably": "static-2.2",
  "highlight.js": "static-1.88",
  "pulse": "static-1.1009",
  "navigation-messaging": "static-1.8288",
  "content-media-composition-data-lib": "static-1.13394",
  "content-media-compositions": "static-2.17401",
  "idb-keyval": "static-1.53",
  "media-bridge-lib": "static-1.19502",
  "nudge-client-utils": "static-1.3251",
  "unified-auth-core-lib": "static-1.1329",
  "social-insights-client-types": "static-1.22759",
  "advanced-menus-core": "static-1.15671",
  "advanced-menus-lib": "static-1.12508",
  "ExportDialog": "static-6.10755",
  "ui-memberships-settings-lib": "static-1.34967",
  "conditional-properties-service-client": "static-1.4060",
  "crm-pipelines-api-client-types": "static-1.4392",
  "fdsr-migration-layer": "static-1.390",
  "framework-builder-read-service-client": "static-1.4266",
  "framework-data-schema-quick-fetch": "static-1.7176",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3954",
  "persist-promise": "static-1.4079",
  "foundations-components-test-utils": "static-1.6083",
  "reactive-lib": "static-1.1097",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.710",
  "universal-page-editor-lib": "static-1.3388",
  "adobe-sign-auth-lib": "static-1.595",
  "ads-unified-auth-lib": "static-1.1620",
  "custom-vendor-connection-lib": "static-1.97",
  "google-sheets-integration-lib": "static-1.1159",
  "microsoft-drive-auth-lib": "static-1.303",
  "surveymonkey-integration-lib": "static-1.649",
  "slack-ui-library": "static-1.10774",
  "bend-plugin-pulse": "static-1.512",
  "event-emitter": "static-1.1334",
  "fast-json-patch": "static-1.72",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3008",
  "nudge-renderer-utils": "static-1.3327",
  "onboarding-tours": "static-1.17241",
  "whisper-core-api": "static-1.7461",
  "fsm": "static-1.4131",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15670",
  "simple-menus-lib": "static-1.17187",
  "settings-ui-lib": "static-1.12900",
  "crm-record-cards-service-types": "static-1.3813",
  "location-customization-utils-lib": "static-1.10238",
  "getting-started-shared-tasks": "static-1.19380",
  "growth-data-modal": "static-1.5992",
  "growth-onboarding-next-action-utils": "static-1.2817",
  "navigation-components": "static-1.18961",
  "onboarding-tours-client": "static-1.5456",
  "onboarding-tours-utils": "static-1.1308",
  "ui-shepherd-tracker": "static-1.8030",
  "user-context": "static-1.5472",
  "react-flip-move": "static-1.80",
  "onboarding-data-sync-lib": "static-1.2651",
  "growth-onboarding-next-action-components": "static-1.2845",
  "user-context-client": "static-1.4885",
  "nest": "static-1.611",
  "getting-started-shared-tasks-store": "static-1.18498",
  "InboxConnectUtils": "static-4.15680",
  "meetings-connect-utils-lib": "static-1.7989",
  "onboarding-scopes": "static-1.6829"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30872",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55437",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8412",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11866",
  "I18n": "/I18n/static-7.1684",
  "quartz": "/quartz/static-1.7545",
  "quartz-config": "/quartz-config/static-1.1323",
  "quartz-core": "/quartz-core/static-1.6764",
  "react-dlb": "/react-dlb/static-1.91",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.82",
  "reselect": "/reselect/static-3.14",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.998",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55424",
  "feedback-utils": "/feedback-utils/static-1.55428",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4841",
  "forms-utils-lib": "/forms-utils-lib/static-1.13189",
  "foundations-assets": "/foundations-assets/static-1.5264",
  "foundations-components": "/foundations-components/static-1.8600",
  "foundations-theming": "/foundations-theming/static-1.4855",
  "hub-http": "/hub-http/static-1.6587",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12173",
  "icons": "/icons/static-2.696",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4169",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.201",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17104",
  "react-select-plus": "/react-select-plus/static-1.115",
  "react-utils": "/react-utils/static-2.5601",
  "react-virtualized": "/react-virtualized/static-2.109",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.510",
  "tinymce-plugins": "/tinymce-plugins/static-1.58346",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1266",
  "UIComponents": "/UIComponents/static-3.8812",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3822",
  "quartz-webpack": "/quartz-webpack/static-1.3769",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2571",
  "property-description-translator": "/property-description-translator/static-1.4200",
  "HeadJS": "/HeadJS/static-2.807",
  "framer-motion": "/framer-motion/static-1.81",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3523",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.11",
  "testing-library": "/testing-library/static-1.161",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.232",
  "moment-timezone": "/moment-timezone/static-5.93",
  "jasmine": "/jasmine/static-4.4687",
  "jasmine-runner": "/jasmine-runner/static-1.6825",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.161",
  "dispatcher": "/dispatcher/static-1.145",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.892",
  "hubspotter-http": "/hubspotter-http/static-1.4904",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.587",
  "module-federation": "/module-federation/static-1.35",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.536",
  "quartz-auth": "/quartz-auth/static-1.1220",
  "quartz-head": "/quartz-head/static-1.1210",
  "quartz-i18n": "/quartz-i18n/static-1.1220",
  "quartz-routing": "/quartz-routing/static-1.975",
  "quartz-test": "/quartz-test/static-1.1220",
  "quartz-tracking": "/quartz-tracking/static-1.924",
  "trellis-components": "/trellis-components/static-1.2854",
  "ui-fonts": "/ui-fonts/static-1.1128",
  "usage-tracker-container": "/usage-tracker-container/static-1.7679",
  "usage-tracker-core": "/usage-tracker-core/static-1.7539",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.266",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7600",
  "reference-resolvers": "/reference-resolvers/static-1.8559",
  "sanitize-text": "/sanitize-text/static-1.8533",
  "PatternValidationJS": "/PatternValidationJS/static-1.3266",
  "ReduxMessenger": "/ReduxMessenger/static-2.10748",
  "outpost": "/outpost/static-1.4514",
  "rpc-client-utils": "/rpc-client-utils/static-1.5042",
  "sanitize": "/sanitize/static-1.4848",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4869",
  "floating-ui": "/floating-ui/static-1.65",
  "hs-story-utils": "/hs-story-utils/static-1.9801",
  "react-aria": "/react-aria/static-1.74",
  "react-create-root-preference": "/react-create-root-preference/static-1.82",
  "tanstack-table": "/tanstack-table/static-1.63",
  "trellis-assets": "/trellis-assets/static-1.2835",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3338",
  "foundations-theming-base": "/foundations-theming-base/static-1.3840",
  "stylex": "/stylex/static-1.43",
  "hs-locale-management": "/hs-locale-management/static-1.340",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.17",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9857",
  "atom": "/atom/static-1.5457",
  "codemirror": "/codemirror/static-5.104",
  "content-assistance-lib": "/content-assistance-lib/static-1.8292",
  "ContentUtils": "/ContentUtils/static-1.69269",
  "data-token-picker": "/data-token-picker/static-1.16985",
  "file-manager-components": "/file-manager-components/static-1.24650",
  "FileManagerCore": "/FileManagerCore/static-1.40149",
  "FileManagerLib": "/FileManagerLib/static-1.40290",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8297",
  "hub-http-contrib": "/hub-http-contrib/static-1.3403",
  "interframe": "/interframe/static-3.5119",
  "layout-dnd-components": "/layout-dnd-components/static-1.13070",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12045",
  "property-translator": "/property-translator/static-1.5757",
  "react-codemirror": "/react-codemirror/static-1.11019",
  "react-colorpicker": "/react-colorpicker/static-2.10590",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8480",
  "rich-text-lib": "/rich-text-lib/static-1.20411",
  "tinymce-data": "/tinymce-data/static-1.41317",
  "tinymce-themes": "/tinymce-themes/static-1.57202",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10247",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5578",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16705",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.17",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.81",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10736",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10734",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5375",
  "base-ui": "/base-ui/static-1.24",
  "react-day-picker": "/react-day-picker/static-1.12",
  "trellis-theming": "/trellis-theming/static-1.1353",
  "tanstack-virtual": "/tanstack-virtual/static-1.40",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.452",
  "chirp-fetch": "/chirp-fetch/static-1.2274",
  "stylex-utils": "/stylex-utils/static-1.151",
  "chatspot-core": "/chatspot-core/static-1.23333",
  "copilot-toolkit": "/copilot-toolkit/static-1.11970",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13407",
  "data-fetching-client": "/data-fetching-client/static-1.10024",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5136",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9055",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29434",
  "usage-tracker": "/usage-tracker/static-1.7689",
  "cms-field-types": "/cms-field-types/static-1.5187",
  "content-icons-ui": "/content-icons-ui/static-1.2411",
  "integrations-lib": "/integrations-lib/static-1.17212",
  "customer-data-objects": "/customer-data-objects/static-1.8067",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1915",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5011",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.96",
  "graphql": "/graphql/static-1.91",
  "immer": "/immer/static-1.103",
  "immerable": "/immerable/static-1.4521",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9456",
  "video-components-external": "/video-components-external/static-1.12269",
  "video-data-lib": "/video-data-lib/static-1.35927",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.571",
  "audio-components": "/audio-components/static-1.6441",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29910",
  "FileManagerImages": "/FileManagerImages/static-1.37801",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1625",
  "html-to-image": "/html-to-image/static-1.63",
  "redux-toolkit": "/redux-toolkit/static-1.80",
  "salesImages": "/salesImages/static-1.638",
  "ui-universal-auth": "/ui-universal-auth/static-1.9533",
  "urlinator": "/urlinator/static-1.4893",
  "video-components": "/video-components/static-1.14271",
  "video-embed": "/video-embed/static-1.36761",
  "ts-schema": "/ts-schema/static-1.4338",
  "ContentData": "/ContentData/static-1.69344",
  "layout-data-lib": "/layout-data-lib/static-1.10370",
  "react-dnd-compat": "/react-dnd-compat/static-1.4991",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1922",
  "external-options-client-types": "/external-options-client-types/static-1.4385",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7271",
  "hs-promise-utils": "/hs-promise-utils/static-1.5966",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4088",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9303",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3441",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.185",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11526",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5815",
  "magpie-types": "/magpie-types/static-1.5275",
  "simple-logging-lib": "/simple-logging-lib/static-1.3428",
  "avatar-components": "/avatar-components/static-1.2860",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10207",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6962",
  "flux-actions": "/flux-actions/static-1.376",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5251",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14627",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5988",
  "laboratory-lib": "/laboratory-lib/static-3.7529",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8142",
  "redux-observable": "/redux-observable/static-1.77",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10649",
  "unified-auth": "/unified-auth/static-1.1047",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.893",
  "breeze-engine-core": "/breeze-engine-core/static-1.1193",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.88",
  "pulse": "/pulse/static-1.1009",
  "navigation-messaging": "/navigation-messaging/static-1.8288",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13394",
  "content-media-compositions": "/content-media-compositions/static-2.17401",
  "idb-keyval": "/idb-keyval/static-1.53",
  "media-bridge-lib": "/media-bridge-lib/static-1.19502",
  "nudge-client-utils": "/nudge-client-utils/static-1.3251",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1329",
  "social-insights-client-types": "/social-insights-client-types/static-1.22759",
  "advanced-menus-core": "/advanced-menus-core/static-1.15671",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12508",
  "ExportDialog": "/ExportDialog/static-6.10755",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34967",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4060",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4392",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.390",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4266",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7176",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3954",
  "persist-promise": "/persist-promise/static-1.4079",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6083",
  "reactive-lib": "/reactive-lib/static-1.1097",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.710",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3388",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.595",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1620",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.97",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1159",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.303",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.649",
  "slack-ui-library": "/slack-ui-library/static-1.10774",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.512",
  "event-emitter": "/event-emitter/static-1.1334",
  "fast-json-patch": "/fast-json-patch/static-1.72",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3008",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3327",
  "onboarding-tours": "/onboarding-tours/static-1.17241",
  "whisper-core-api": "/whisper-core-api/static-1.7461",
  "fsm": "/fsm/static-1.4131",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15670",
  "simple-menus-lib": "/simple-menus-lib/static-1.17187",
  "settings-ui-lib": "/settings-ui-lib/static-1.12900",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3813",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10238",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19380",
  "growth-data-modal": "/growth-data-modal/static-1.5992",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2817",
  "navigation-components": "/navigation-components/static-1.18961",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5456",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1308",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8030",
  "user-context": "/user-context/static-1.5472",
  "react-flip-move": "/react-flip-move/static-1.80",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2651",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2845",
  "user-context-client": "/user-context-client/static-1.4885",
  "nest": "/nest/static-1.611",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18498",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15680",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7989",
  "onboarding-scopes": "/onboarding-scopes/static-1.6829"
}
};
